import React, { useState } from "react";
import { TRADES } from "@/lib/trades";
import { Input } from "@/components/ui/input";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

// Chip multi-select of canonical trades. Controlled: value=string[], onChange(next).
export function TradePicker({ value = [], onChange }) {
  const [q, setQ] = useState("");
  const toggle = (t) => onChange(value.includes(t) ? value.filter((x) => x !== t) : [...value, t]);
  const list = TRADES.filter((t) => t.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="trade-picker">
      <Input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search trades…"
        className="h-10"
        data-testid="trade-search"
      />
      <div className="mt-3 flex flex-wrap gap-2">
        {list.map((t) => {
          const on = value.includes(t);
          return (
            <button
              key={t}
              type="button"
              data-testid={`trade-chip-${t}`}
              onClick={() => toggle(t)}
              className={cn(
                "flex items-center gap-1 rounded-full border px-3 py-1.5 text-sm transition-colors",
                on
                  ? "border-emerald-500 bg-emerald-500/15 text-emerald-400"
                  : "border-border text-muted-foreground hover:border-emerald-500/40"
              )}
            >
              {on && <Check className="h-3.5 w-3.5" />} {t}
            </button>
          );
        })}
        {list.length === 0 && <p className="text-sm text-muted-foreground">No trades match “{q}”.</p>}
      </div>
    </div>
  );
}
